// components/SEOHelmet.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const SeoHelmet = ({
  title = "پوریا صبوری | توسعه‌دهنده فرانت‌اند و React | pouriya sabouri",

  description = "پوریا صبوری، توسعه‌دهنده فرانت‌اند با تخصص در React، Next.js و تجربه ساخت وب‌اپلیکیشن‌های مدرن و ریسپانسیو | pouriya sabouri - Frontend Developer specializing in React, Next.js, and modern web applications",

  keywords = "پوریا صبوری, pouriya sabouri, توسعه‌دهنده فرانت‌اند, frontend developer, react developer, next.js, portfolio, نمونه کار, رزومه آنلاین, برنامه‌نویس وب",

  author = "pouriya sabouri | پوریا صبوری",

  ogTitle,

  ogDescription,

  ogImage = "/blue-lilly.png",

  ogUrl,

  ogType = "website",

  siteName = "پوریا صبوری | pouriya sabouri portfolio",

  category = "portfolio | نمونه کار",
}) => {
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const finalOgUrl = ogUrl || currentUrl;

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />

      <meta name="robots" content="index, follow" />

      <meta name="revisit-after" content="7 days" />

      <meta name="language" content="fa, en" />

      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      <link rel="canonical" href={finalOgUrl} />

      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={`${title} - screenshot preview`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={finalOgUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="fa_IR" />
      <meta property="og:locale:alternate" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={`${title} - preview`} />
      <meta name="twitter:creator" content="@pouriya_sabouri" />
      <meta name="twitter:site" content="@pouriya_sabouri" />

      <meta name="theme-color" content="#0f172a" />
      <meta name="msapplication-navbutton-color" content="#0f172a" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#0f172a" />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          name: "پوریا صبوری",
          alternateName: "pouriya sabouri",
          url: currentUrl,
          jobTitle: "Frontend Developer",
          description: description,
          sameAs: ["https://github.com/pouriya-3a"],
          knowsAbout: [
            "React",
            "Next.js",
            "JavaScript",
            "TypeScript",
            "Frontend Development",
          ],
          image: ogImage,
          email: "pouriyasabouri1385@gmail.com",
        })}
      </script>

      <meta name="rating" content="General" />
      <meta name="distribution" content="Global" />
    </Helmet>
  );
};

export default SeoHelmet;
